import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const vaultApi = createApi({
  reducerPath: "vaultApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/vault`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Vault"],
  endpoints: (builder) => ({
    getVaults: builder.query({
      query: () => "/",
      providesTags: ["Vault"],
    }),
    getVaultById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "Vault", id }],
    }),
    addVault: builder.mutation({
      query: (body) => ({
        url: "/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Vault"],
    }),
    updateVault: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Vault"],
    }),
    deleteVault: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Vault"],
    }),
  }),
});

export const {
  useGetVaultsQuery,
  useGetVaultByIdQuery,
  useAddVaultMutation,
  useUpdateVaultMutation,
  useDeleteVaultMutation,
} = vaultApi;
